import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "app/auth/base";
import { closeLoading, openLoading } from "app/store/trackingApp/loadingSlice";
import { openModalError } from "app/store/trackingApp/modalErrorSlice";

const parseObject = (obj) => {
  let newObj = {};
  Object.keys(obj).forEach((key) => {
    if (key !== "pagina" && key !== "itensPorPagina") {
      newObj[key] = obj[key];
    }
  });
  return newObj;
};

export const getDataCrlPedidos = createAsyncThunk(
  "crlApp/pedidos/getDataCrlPedidos",
  async (data: any, { dispatch }) => {
    const { pagina, itensPorPagina } = data;
    let response;
    dispatch(openLoading());
    try {
      response = await API.get(
        `/crl/pedidos/json/${itensPorPagina}/${pagina}`,
        {
          params: parseObject(data),
          paramsSerializer: {
            indexes: null,
          },
        }
      );
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Erro ao exibir dados",
          text: "Verifique se os dados digitados estão corretos!",
          btnLabel: "Voltar",
        })
      );
      console.error(err);
    }
    dispatch(closeLoading());
    return response.data;
  }
);
